var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarResources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9317",
    "data-name": "Group 9317",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17.266,
    viewBox: "0 0 16 17.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9316",
    "data-name": "Group 9316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13563",
    "data-name": "Path 13563",
    d: "M14,2H6A1.884,1.884,0,0,0,4,3.727V17.539a1.874,1.874,0,0,0,1.99,1.727H18a1.884,1.884,0,0,0,2-1.727V7.18Zm4,15.539H6V3.727h7V8.043h5Z",
    transform: "translate(-4 -2)",
    fill: "#659ac3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13564",
    "data-name": "Path 13564",
    d: "M8.9,10.9a3.036,3.036,0,0,0,3.593,4.82l1.636,1.636,1.227-1.227-1.636-1.636A3.036,3.036,0,0,0,8.9,10.9Zm3.071,3.071a1.3,1.3,0,1,1,0-1.844A1.3,1.3,0,0,1,11.967,13.967Z",
    transform: "translate(-3.451 -3.345)",
    fill: "#659ac3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarResources);
export default __webpack_public_path__ + "static/media/sidebar_resources.7c7424a660fd5ad13b5130a31c96fdbc.svg";
export { ForwardRef as ReactComponent };